import { render, staticRenderFns } from "./CompanyExpand.vue?vue&type=template&id=e24676f2&"
import script from "./CompanyExpand.vue?vue&type=script&lang=js&"
export * from "./CompanyExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/CompanyExpand.vue
// module id = null
// module chunks = 